"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = exports.colors = void 0;
var colors_1 = require("./colors");
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return __importDefault(colors_1).default; } });
var palette_1 = require("./palette");
Object.defineProperty(exports, "palette", { enumerable: true, get: function () { return __importDefault(palette_1).default; } });
//# sourceMappingURL=index.js.map